import {
  DialogContent,
  type SxProps,
  Typography,
  useTheme,
} from '@mui/material';
import { isMobile } from 'react-device-detect';
import { ReactNode } from 'react';
import BaseDialog, {
  SharedDialogProps,
} from 'components/Modals/BaseDialog/BaseDialog';

type ConversionDialogProps = {
  subtitle?: string;
  description?: string;
  children?: ReactNode;
  submitButtonStyle?: SxProps;
} & SharedDialogProps;

const ConversionDialog = ({
  subtitle,
  description,
  children,
  submitButtonStyle,
  ...otherProps
}: ConversionDialogProps) => {
  const theme = useTheme();

  return (
    <BaseDialog
      titleStyle={{
        textAlign: 'center',
      }}
      submitButtonStyle={{
        width: '100%',
        ...submitButtonStyle,
      }}
      closeStyle={{
        marginTop: theme.spacing(3),
        width: '100%',
      }}
      actionsContainerStyle={{ flexDirection: 'column-reverse' }}
      {...otherProps}
    >
      <DialogContent
        data-testid="conversion-dialog-description"
        sx={{
          alignContent: 'center',
          textAlign: 'center',
          backgroundColor: theme.palette.grey[50],
          padding: isMobile ? theme.spacing(2.5, 0) : undefined,
        }}
      >
        {subtitle && (
          <Typography
            sx={{
              color: theme.palette.grey[900],
              mb: theme.spacing(2),
            }}
          >
            {subtitle}
          </Typography>
        )}
        <Typography sx={{ color: theme.palette.grey[900] }}>
          {description}
        </Typography>
        {children}
      </DialogContent>
    </BaseDialog>
  );
};

export default ConversionDialog;
